import { Link } from 'react-router-dom';

import SignupForm from '../sign-up-form/sign-up-form.component';

import Social from '../socials/social.component';

import './footer.styles.scss';


const Footer = () => {
    const navigations = [
        {
            name: 'Home',
            linked: '../'
        },
        {
          name: 'About Us',
          linked: '../aboutus'
        },
        {
          name: 'Services',
          linked: '../services'
        },
        {
          name: 'Privacy & Legal',
          linked: '../privacy&legal',
        },
        // {
        //   name: 'Resources/Blog',
        //   linked: '../blogs',
        // },
        {
          name: 'Contact Us',
          linked: '../contactus',
    }];

    return (
        <div className='footer'>
            {/* <div class="klaviyo-form-RaLuFy"></div> */}
            <SignupForm />

            <div 
                className='info-box'
                style={{
                    flexDirection: window.screen.width <= 1000 ? 'column' : 'row'
                }}
            >
                <div 
                    className='navigation-container'
                    style={{
                        width: window.screen.width <= 1000 ? '100%' : '600px'
                    }}
                >
                    <span>
                        {
                            navigations.map((op) => <Link key={op.name} to={op.linked} style={{ 
                                color: 'inherit',
                                textDecoration: 'inherit',
                                // wordSpacing: '10px',
                                marginRight: '15px',
                                // textOverflow: 'ellipsis'
                                
                            }} >
                                {op.name}
                            </Link>
                            )
                        }
                    </span>

                </div>

                <Social />
                
            </div>
            
            <span className='copy'>
                Tree Inc &#169;  2025
            </span>
        </div>
    )
}

export default Footer;